import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError, from } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);
  const http = inject(HttpClient);

  let token: string | null = null;
  let expireAt: string | null = null;
  let refreshToken: string | null = null;

  if (isPlatformBrowser(platformId)) {
    token = localStorage.getItem('authToken');
    expireAt = localStorage.getItem('expireAt');
    refreshToken = localStorage.getItem('refreshToken');
  }

  // ✅ Attach token if available
  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  // ✅ Check expiry before sending request
  if (expireAt && new Date(expireAt) <= new Date() && refreshToken) {
    return from(
      http.post(`${environment.apiUrl}/auth/refresh`, { refreshToken }).toPromise()
    ).pipe(
      switchMap((res: any) => {
        if (res?.success && res.data?.sessionToken) {
          // 🔄 Save new tokens
          localStorage.setItem('authToken', res.data.sessionToken);
          localStorage.setItem('expireAt', res.data.expireAt);
          localStorage.setItem('refreshToken', res.data.refreshToken);

          // Retry original request with new token
          const clonedReq = req.clone({
            setHeaders: { Authorization: `Bearer ${res.data.sessionToken}` },
          });
          return next(clonedReq);
        } else {
          // ❌ Refresh failed → clear + redirect
          localStorage.clear();
          router.navigateByUrl('');
          return throwError(() => new Error('Refresh token failed'));
        }
      }),
      catchError(() => {
        // ❌ Refresh request failed
        localStorage.clear();
        router.navigateByUrl('');
        return throwError(() => new Error('Refresh token failed'));
      })
    );
  }

  // ✅ Normal flow, but catch 401
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.clear();
        router.navigateByUrl('');
      }
      return throwError(() => error);
    })
  );
};
